import { $themeConfig } from '@themeConfig'


export const useVerticalMenuStore = defineStore('vertical-menu',() => {
  const isVerticalMenuCollapsed = ref(JSON.parse(localStorage.getItem('vertical_menu_collapse')) ? JSON.parse(localStorage.getItem('vertical_menu_collapse')) : $themeConfig.layout.menu.isCollapsed);

  const UPDATE_VERTICAL_MENU_COLLAPSED = (val) => {
      localStorage.setItem('vertical_menu_collapse', val)
      isVerticalMenuCollapsed.value = val
  }

  return {
    isVerticalMenuCollapsed,

    UPDATE_VERTICAL_MENU_COLLAPSED
  };

});

export default useVerticalMenuStore;